// extracted by mini-css-extract-plugin
export var displayNone = "_qp-6";
export var imgContainer = "_qp-2";
export var overflowHidden = "_qp-3";
export var productInfoCardButtonContainer = "_qp-5";
export var productTitleText = "_qp-4";
export var rightArrow = "_qp-1";
export var rightArrowContainer = "_qp-0";